module.exports = __webpack_public_path__ + "prod/1.42.2/img/mixOsBanner-small.5e3c9535.png";